import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentTypePage = {
  alert: {
    error: 'applicant-employment-type-page.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-type-page.footer.root',
  },
  form: {
    h1: 'applicant-employment-type-page.form.h1',
    h2: 'applicant-employment-type-page.form.h2',
    radioGroupRoot: 'applicant-employment-type-page.form.radio-group-root',
    radioOption1: 'applicant-employment-type-page.form.radio-option-1',
    radioOption2: 'applicant-employment-type-page.form.radio-option-2',
    radioOption3: 'applicant-employment-type-page.form.radio-option-3',
    radioOption4: 'applicant-employment-type-page.form.radio-option-4',
    root: 'applicant-employment-type-page.form.root',
    submitButton: 'applicant-employment-type-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
